/**
 * @generated SignedSource<<2f0ad496f4d174c07290252d014924cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberCurriculumProgressBarFragment$data = {
  readonly curriculumReport: {
    readonly completedModules: number;
    readonly releasedModules: number;
    readonly totalModules: number;
  };
  readonly id: string;
  readonly " $fragmentType": "MemberCurriculumProgressBarFragment";
};
export type MemberCurriculumProgressBarFragment$key = {
  readonly " $data"?: MemberCurriculumProgressBarFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberCurriculumProgressBarFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberCurriculumProgressBarFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductMembershipCurriculumReport",
      "kind": "LinkedField",
      "name": "curriculumReport",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalModules",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "releasedModules",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "completedModules",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductMembership",
  "abstractKey": null
};

(node as any).hash = "24bfb94dd63f90cf1430c8376fa9b145";

export default node;
